module.exports = __webpack_public_path__ + "static/media/tuff2.fcbc89f6.mp4";